module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANAQMAAABFOwZ4AAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAABhJREFUCNdj4GNg+P8AhOoPgFAWOoKIAwAv6w/FsRLyqQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_delete.png
// module id = dSeH
// module chunks = 9